// @flow

// Types
import type {
  ImportJobsPopupOperation,
} from '../../types'

// Operator
import operator from '../operator'

// Effect Managers
import { fork, race, take } from 'redux-saga/effects'


type OperationsArgs = {
  operations$: (state: Object) => Array<ImportJobsPopupOperation>
}

// Exports
export default function *watchOperations ({operations$}: OperationsArgs): Generator<*, void, *> {
  yield take([operator.actionTypes.add()])
  yield fork(handleOperations, {operations$})
}

export function *handleOperations ({operations$}: OperationsArgs): Generator<*, void, *> {
  let done = false

  while (!done) {
    const effect = yield race({
      submit: take(operator.actionTypes.submitOperations()),
      cancel: take(operator.actionTypes.cancelOperations()),
    })

    if (effect.cancel) {
      done = true
    }
  }
}
